require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responding-to-mental-health-crisis-calls.json") })
        }
      }, "path---responding-to-mental-health-crisis-calls");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responding-to-mental-health-crisis-calls!./.cache/json/responding-to-mental-health-crisis-calls.json
// module id = 975
// module chunks = 231608221292675